import { useCallback, useEffect, useState } from 'react';
import { TimeZone } from '@connect-x-app/shared-domain-models';
import { getNow } from '@connect-x-app/shared-utils';

export const useDate = (timeZone: TimeZone) => {
  const getFormattedTime = useCallback(() => {
    return getNow().toLocaleTimeString('en', {
      hour: 'numeric',
      hourCycle: 'h24',
      minute: 'numeric',
      timeZone: timeZone === TimeZone.UTC ? 'UTC' : undefined,
    });
  }, [timeZone]);

  const [time, setTime] = useState(getFormattedTime());

  useEffect(() => {
    setTime(getFormattedTime());

    const timer = setInterval(() => {
      setTime(getFormattedTime());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [getFormattedTime]);

  return {
    time,
  };
};
